<template src="./Searchbar.html"></template>
<style src="./Searchbar.scss" lang="scss"></style>

<script>
  import Input from '@/components/Input/Input'
  import { Helper } from '@/services/helper/helper'

  /**
   * The searchbar with button in the homepage.
   * @vue-data {Object} searchbarInput An object representing the input bar for search
   * @vue-data {string} searchURL The endpoint where searchbar should lead to
   * @vue-data {Object} trackParams An object representing tracking parameters for search, suggest and layer
   * @vue-data {number} suggestIndex The chosen suggest link
   */
  export default {
    name: 'HpSearchbar',
    data () {
      return {
        searchbarInput: {
          htmlId: 'searchbar' + this._uid,
          inputType: 'search',
          ariaPlaceholder: 'google', // for identifying search machine
          inputvalue: '',
          name: 'q',
          maxLength: 1024,
          suggest: {
            id: this.$store.state.contentData.searchbar.suggestContainerId,
            url: this.$store.state.contentData.searchbar.suggestAPI,
            response: ''
          }
        },
        searchURL: this.$store.state.contentData.searchbar.searchURL,
        trackParams: this.$store.state.contentData.searchbar.trackParams,
        suggestIndex: -1
      }
    },
    methods: {
      searchSubmit (ev) {
        ev.preventDefault()
        const form = this.$el.querySelector('form') || ''
        let variant = document.querySelector('html').getAttribute('data-variant-name')

        if (!form) {
          return
        }

        if (Helper.getElementByAttribute(this.$el, '[data-component="layer"]')) {
          form.origin.value = this.trackParams.layer
        } else {
          form.origin.value = this.suggestIndex < 0 ? this.trackParams.default : this.trackParams.suggest
        }
        form.submit()
      },
      searchReset () {
        let form = this.$el.querySelector('form') || ''
        form && form.reset()
        this.searchbarInput.inputvalue = ''
      },
      getSuggestIndex (obj) {
        this.suggestIndex = obj.index
      }
    },
    components: {
      'hp-input': Input
    }
  }
</script>
